import { z } from 'zod'

/** Settings › Working calendar keeps the year shown in the URL; an invalid year falls back to this one. */
export const calendarSearchSchema = z.object({
  year: z.number().int().min(2000).max(2100).optional().catch(undefined),
})

export type CalendarSearch = z.infer<typeof calendarSearchSchema>
